import React, { useEffect, useRef, useState } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import TagSlider from "../../../../Common/TagSlider";
import CustomSelect from "../../../../FormFields/CustomSelect";
import CustomTreeSelect from "../../../../FormFields/CustomTreeSelect";
import EmojiPicker from "emoji-picker-react";
import { Assets } from "../../../../../constants/images";
import { roles as salonRoles } from "../../../../../utils/constants";
import { GetAuthUserLocalStorage } from "../../../../../services/localStorage/localStorage";
import { setCreateUpdateModuleTitle } from "../../../../../store/slices/globalSlice";

const SecondStep = ({
  register,
  watch,
  control,
  setValue,
  getValues,
  errors,
  title,
  handleTreeSelectValue,
}) => {
  const dispatch = useDispatch();
  const selectedCategory = watch("category");
  const recipients = watch ? watch("recipients") : [];
  const recipientType = watch ? watch("recipientType") : "";

  const { categories } = useSelector((state) => state.global);

  const emojiPickerRef = useRef(null);
  const [showPicker, setShowPicker] = useState(false);
  const showPickerShowHide = useRef(false);
  const containerRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  function handleEmojiClick(emojiData) {
    setValue("resourceTitle", getValues("resourceTitle") + emojiData.emoji);
  }

  const handleCheckEmojiClick = (event) => {
    if (
      emojiPickerRef.current &&
      !emojiPickerRef.current.contains(event.target) &&
      showPicker
    ) {
      setShowPicker(false);
    }
  };

  useEffect(() => {
    window.addEventListener("click", handleCheckEmojiClick);
    return () => {
      window.removeEventListener("click", handleCheckEmojiClick);
    };
  }, [showPicker]);

  return (
    <>
      <Form>
        <Row>
          <Col
            lg={
              GetAuthUserLocalStorage()?.roles[0]?.id !== salonRoles.super_admin
                ? 8
                : 12
            }
          >
            <FloatingLabel
              controlId="resourceTitle"
              label="Resource Title"
              className="mb-20"
            >
              <Form.Control
                type="text"
                placeholder="Resource Title"
                autoComplete="off"
                role={"presentation"}
                className={errors.resourceTitle ? "hasError" : ""}
                minLength={1}
                maxLength={100}
                {...register("resourceTitle", {
                  onChange: (e) => {
                    dispatch(setCreateUpdateModuleTitle(e.target.value));
                  },
                  required: {
                    value: "Resource Title is required",
                  },
                  minLength: {
                    value: 1,
                  },
                  maxLength: {
                    value: 100,
                  },
                })}
              />
              <div ref={emojiPickerRef}>
                <div
                  onClick={() => {
                    setShowPicker(!showPicker);
                  }}
                  className={"smileyBox"}
                >
                  <img src={Assets.Smile} className={"smileImage"} />
                </div>
                {showPicker && <EmojiPicker onEmojiClick={handleEmojiClick} />}
              </div>
            </FloatingLabel>
          </Col>
          {GetAuthUserLocalStorage()?.roles[0]?.id !==
            salonRoles.super_admin && (
            <Col lg={4}>
              <div className="form-floating">
                <CustomTreeSelect
                  label="Recipients"
                  placeholder="Recipients"
                  defaultSelectedData={recipients}
                  handleChange={handleTreeSelectValue}
                  selectedCategory={
                    recipientType === 1001
                      ? "everyone"
                      : recipientType === 1002
                        ? "group"
                        : recipientType === 1003
                          ? "member"
                          : null
                  }
                />
              </div>
            </Col>
          )}
          <Col lg={4}>
            <Controller
              control={control}
              name="category"
              defaultValue={""}
              rules={{
                required: "Category is required",
              }}
              render={({ field: { onChange, value } }) => (
                <FloatingLabel
                  controlId="category"
                  label={value == "" ? "Category" : ""}
                  className="mb-20"
                >
                  <CustomSelect
                    value={value}
                    label="Category"
                    options={categories.filter((elem) => elem.value != 0)}
                    className={value == "" ? "hasError" : ""}
                    onChange={(e) => {
                      setValue("tags", "");
                      onChange(e);
                    }}
                    placeholder="Category"
                  />
                </FloatingLabel>
              )}
            />
          </Col>
          <Col lg={8} className={`mb-20 ${selectedCategory ? "" : "d-none"}`}>
            <Controller
              control={control}
              name="tags"
              rules={{
                required: "Tag are required",
              }}
              render={({ field: { onChange, onBlur, value, ref } }) => (
                <TagSlider
                  value={value}
                  handleChange={onChange}
                  categoryId={selectedCategory}
                  title={title}
                />
              )}
            />
          </Col>
          <Col lg={12}>
            <FloatingLabel
              controlId="description"
              label="Description (Optional)"
              className="mb-20 custom-textarea "
            >
              <Form.Control
                as="textarea"
                placeholder="Improve your coloring knowledge with this PDF resource."
                style={{ height: "200px" }}
                className={`form-control ${errors.description ? "hasError" : ""}`}
                minLength={0}
                maxLength={5000}
                {...register("description", {
                  required: {
                    value: false,
                  },
                  minLength: {
                    value: 0,
                  },
                  maxLength: {
                    value: 5000,
                  },
                })}
              />
            </FloatingLabel>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default SecondStep;
